"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const season_fragment_1 = __importDefault(require("../fragments/season.fragment"));
const query = (0, client_1.gql) `
  query season($seasonId: String!) {
    season(seasonId: $seasonId) {
      _id
      orgId
      name
      subtitle
      description
      userAgreement
      processAs
      posterImageUrl {
        original
        medium
        small
      }
      venueId
      createdAt
      publishable
      seatingChartKey
      seatingPublicKey
      age
      sendQRCode
      hasOrders
      taxDeduction
      organization {
        orgName
        stripeId
        googleAnalyticsId
        facebookPixelId
        isTegIntegration
        tegClientID
        tegSecret
        tegURL
      }
      venue {
        _id
        name
        address {
          state
          city
        }
        imageUrls
      }
      published
      salesBeginImmediately
      isGuestTicketSale
      ...SeasonSchedule
      ...Location
      ...Performances
      ...TicketTypes
      ...TicketHolds
      ...SeasonUpgrades
      ...SeasonPromotions
      ...SeasonCustomFields
      ...TicketExchange
      ...Fees
      ...Artists
      ...WebFlowEntity
      ...Analytics
      ...SeasonEvents
    }
  }

  ${season_fragment_1.default.fragments.schedule}
  ${season_fragment_1.default.fragments.location}
  ${season_fragment_1.default.fragments.performances}
  ${season_fragment_1.default.fragments.ticketTypes}
  ${season_fragment_1.default.fragments.holds}
  ${season_fragment_1.default.fragments.upgrades}
  ${season_fragment_1.default.fragments.promotions}
  ${season_fragment_1.default.fragments.customFields}
  ${season_fragment_1.default.fragments.exchange}
  ${season_fragment_1.default.fragments.fees}
  ${season_fragment_1.default.fragments.artists}
  ${season_fragment_1.default.fragments.webFlowEntity}
  ${season_fragment_1.default.fragments.analytics}
  ${season_fragment_1.default.fragments.Events}
`;
exports.default = query;
//# sourceMappingURL=publicSeason.query.js.map